// import 'core-js/es6/set'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Element from 't-tyui';
import 't-tyui/lib/theme-chalk/index.css';
import "./assets/styles/color.scss";

import './styles/fonts/iconfont.css'
// import './icons' // icon
import '../static/css/font-awesome.min.css'
import './styles/index.scss'
import './styles/buildPlatform.css'
import './styles/buildPlatform-ml.css'

import Global from '@/base/global'
import zh from '@/utils/lang/zh'
import en from '@/utils/lang/en'
import textOverflow from '@/components/textOverflow'
import emptyBox from '@/components/emptyBox'
import * as echarts from 'echarts'
import moment from 'moment'
import lodash from 'lodash'
import store from './store/store'
import routerFun from './router'
import App from './App.vue'
import '@/directives'
import VueClipboard from 'vue-clipboard2'
import ResizeContainer from '@/components/ResizeContainer'

Vue.component('textOverflow', textOverflow)
Vue.component('EmptyBox', emptyBox)

Vue.use(VueClipboard)
Vue.use(ResizeContainer)
Vue.prototype.Global = new Global(Vue)
window.$bus = Vue.prototype.$bus = new Vue()
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment
Vue.prototype.$lodash = lodash
Vue.use(VueI18n)
Vue.use(Element);
const i18n = new VueI18n({
  locale: 'zh', // 语言标识
  messages: {
    zh: zh,
    en: en
  },
  silentTranslationWarn: true // warning 不再显示
})
Vue.config.productionTip = false

/**
 * 全局的loading处理和异常捕获
 * @param {Function} func 传入的方法
 * @param  {Object} params 方法调用的参数
 * @param  {String|Array} loads 重置的loading
 * @returns {Array} [err, res]
 */
Vue.prototype.$reqFn = async function (fn, params, loads, params1 = '') {
  function setLoad(loads, Boolean) {
    if (loads) {
      if (loads instanceof Array) {
        loads.forEach(e => {
          this[e] = Boolean
        })
      } else if (typeof loads === 'string') {
        this[loads] = Boolean
      }
    }
  }
  try {
    setLoad.call(this, loads, true)
    const res = await fn(params, params1)
    setLoad.call(this, loads, false)
    return [null, res]
  } catch (e) {
    setLoad.call(this, loads, false)
    return [e, null]
  }
};

Vue.prototype.setPageWrapPadding = function () {
  Vue.prototype.$nextTick(() => {
    Vue.prototype.$nextTick(() => {
      document.querySelector('.pageWrap').style.padding = '0px'
    })
  })
}
Vue.prototype.getPageWrapPadding = function () {
  Vue.prototype.$nextTick(() => {
    Vue.prototype.$nextTick(() => {
      document.querySelector('.pageWrap').style.padding = '16px 0px 0px 0px'
    })
  })
}

Vue.prototype.charLen = function (text) {
  const cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g
  const mat = text.match(cnReg)
  if (mat) {
    return mat.length * 1 + (text.length - mat.length)
  }
  return text.length
}
Vue.prototype.getByteLen = function (text, type) {
  if (type === 2) {
    text = text.replace(/,/g, '')
  }
  let len = 0
  for (let i = 0; i < text.length; i++) {
    const length = text.charCodeAt(i)
    if (length >= 0 && length <= 128) {
      len += 1
    } else {
      len += 2
    }
  }
  return len
}
Vue.prototype.bLoad = false

String.prototype.endWith = function (str) {
  if (str == null || str == '' || this.length == 0 || str.length > this.length) { return false }
  if (this.substring(this.length - str.length) == str) { return true } else { return false }
  return true
}

String.prototype.startWith = function (str) {
  if (!str || str == '' || this.length == 0 || str.length > this.length) { return false }
  if (this.substr(0, str.length) == str) { return true } else { return false }
  return true
}

String.prototype.realLength = function () {
  return this.replace(/[^\x00-\xff]/g, '**').length // [^\x00-\xff] - 匹配非双字节的字符
}
String.prototype.realSubstring = function (n) {
  var str = this || ''
  if (this.realLength() <= n) { return this }
  var m = Math.floor(n / 2)
  for (var i = m; i < this.length; i++) {
    if (this.substr(0, i).realLength() >= n) {
      return this.substr(0, i)
    }
  }
  return this
}

new Vue({
  router: routerFun(store),
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
